import { render, staticRenderFns } from "./AssignSalesmanModal.vue?vue&type=template&id=706709a2&"
import script from "./AssignSalesmanModal.vue?vue&type=script&lang=js&"
export * from "./AssignSalesmanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports